import React from "react";
import { Link } from "react-router-dom";
const ThankYouModal = ({ onClose,texttoShow }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-full max-w-sm p-6 bg-white rounded-2xl shadow-lg text-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <img src="/closemark.png" alt="close" />
        </button>

        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full">
          <img src="/checkmarkcircle.png" alt="tickmark" />
        </div>

        <h2 className="text-xl font-semibold text-gray-800">Thank you!</h2>
        <p className="mt-2 text-gray-600">
          {texttoShow}
          
        </p>

        <Link to="/coaler"><button
          onClick={() => {
            onClose();
            const homeSection = document.getElementById("coaler");
            if (homeSection) {
              homeSection.scrollIntoView({ behavior: "smooth" });
            }
          }}
          className=" w-full mt-6 px-2 py-2 bg-indigo-800 text-white rounded-lg hover:bg-indigo-900 transition"
        >
          Go to homepage
        </button></Link>
      </div>
    </div>
  );
};

export default ThankYouModal;
